import { Outlet } from "react-router-dom";
import Footer from "./Components/Footer";
import Nav from "./Components/Nav";
import UserProvider from "./context/userContext";
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

// import Banner from "./Components/Banner";

const App = () => {
  const { t } = useTranslation();

  return (
    <UserProvider>
      <Helmet>
        <html lang={t("meta.langCode")} />
        <title>{t("meta.title")}</title>
        <meta name="description" content={t("meta.description")} />

        <meta property="og:title" content={t("meta.title")} />
        <meta property="og:description" content={t("meta.description")} />
        <meta property="og:url" content="https://www.dominoapunte.com" />

        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Domino Apunte" />
        <meta property="og:locale" content={t("meta.langCode")} />
      </Helmet>

      <main style={{ overflow: "hidden" }}>
        <Nav />
        {/* <Banner /> */}
        <Outlet />
        <Footer />
      </main>
    </UserProvider>
  );
};

export default App;
